module.exports = __webpack_public_path__ + "static/2-1324b046b2119fb4d57b2fc098f0d394.jpg";